<template>
  <div class="">
    <h5 class="dialogTitle margin-bottom-0" v-show="!isHieuChinh">
      Ban hành văn bản
    </h5>
    <el-form
      ref="form"
      :model="form"
      :rules="validationRules"
      label-position="top"
    >
      <el-form-item
        class="input-no__label input-header__title input-header__docs"
        prop="quote"
      >
        <label class="label">Trích yếu</label>
        <el-input
          v-model="quote"
          type="textarea"
          autosize
          resize="none"
          placeholder="Nhập trích yếu văn bản"
          maxlength="500"
          :class="[
            'input-border__radius__0',
            quote ? 'has-border__bottom' : 'input-border__bottom',
            'input-border__bottom',
          ]"
          size="medium"
          disabled
        />
      </el-form-item>

      <el-row :gutter="12" class="">
        <el-col :span="12">
          <el-form-item label="Chọn sổ đi" prop="bookId">
            <el-select
              :disabled="isDaBanHanh || isChonSo"
              clearable
              filterable
              v-model="form.bookId"
              size="medium"
              placeholder="-"
              class="
                style-fullWidth
                input-border__bottom input-border__radius__0
              "
              @change="bookIdChange"
            >
              <el-option
                v-for="item in books"
                :label="item.bookName"
                :key="item.id"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="-" class="none-label">
            <el-button
              :disabled="isDaBanHanh"
              class="btnSolid__blue"
              size="medium"
              @click="isOpenDialogAddBookNumber = true"
            >
              <i class="fas fa-mouse-pointer"></i>
              &nbsp;Chọn số đã book
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" class="">
        <el-col :span="4">
          <el-form-item label="Số đi" prop="bookNumber">
            <el-input-number
              :disabled="isDaBanHanh || isChonSo"
              class="
                style-fullWidth
                input-border__bottom input-border__radius__0
              "
              v-model="form.bookNumber"
              size="medium"
              placeholder="-"
              @change="bookNumberChange"
              :controls="false"
              :min="0"
              :step="1"
              :precision="0"
              :max="1000000"
            ></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="11">
          <el-form-item label="Số ký hiệu" prop="docCode">
            <el-input
              :disabled="isDaBanHanh"
              class="
                style-fullWidth
                input-border__bottom input-border__radius__0
              "
              v-model="form.docCode"
              size="medium"
              placeholder="-"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item label="Ngày văn bản" prop="docDate">
            <el-date-picker
              :disabled="isDaBanHanh || isChonSo"
              class="
                style-fullWidth
                input-border__bottom input-border__radius__0
              "
              v-model="form.docDate"
              type="date"
              :prefix-icon="' '"
              placeholder="dd/mm/yyyy"
              size="medium"
              format="dd/MM/yyyy"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="select-Unit-BanHanh">
        <!--ban hành đến (đơn vị bên trong)-->
        <div class="label flex-row flex__left">
          Ban hành đến (đơn vị bên trong)
        </div>
        <div class="margin-bottom-10">
          <el-table
            ref="receiversDataTable"
            :data="receiversDataInfo"
            size="mini"
            style="width: 100%"
            stripe
          >
            <el-table-column
              align="center"
              header-align="center"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              label="Người/Đơn vị được chuyển "
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.userDeptRole"
                  class="flex-row flex__left user_selected"
                >
                  <div class="flex-row lex__left">
                    <!--                    <div class="avatar_fake flex-row flex__center">-->
                    <!--                      <span>{{buildShortName(scope.row.fullName)}}</span>-->
                    <!--                    </div>-->
                    <div class="info margin-left-10">
                      <p class="people__name margin-0">
                        {{ scope.row.userDeptRole.fullName }}
                      </p>
                      <p class="people__position margin-0">
                        {{ scope.row.userDeptRole.positionName }} -
                        {{ scope.row.userDeptRole.deptName }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="unit_selected" v-else>
                  <span class="margin-left-10">{{
                    scope.row.department.deptName
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" width="60">
              <template #header>
                <span class="margin-0 item flex-col flex__center">
                  <span class="margin-bottom-5">Chủ trì</span>
                  <span>
                    <el-radio
                      class="hidden-label-radio"
                      v-model="processType"
                      :label="PROCESS_TYPE.CHUTRI"
                      @change="checkAllProcessType"
                    >
                    </el-radio>
                  </span>
                </span>
              </template>
              <template slot-scope="scope">
                <span class="item flex-col flex__center">
                  <el-radio
                    class="item txt-center hidden-label-radio"
                    v-model="scope.row.processType"
                    :label="PROCESS_TYPE.CHUTRI"
                    @change="refreshProcessType()"
                  >
                  </el-radio>
                </span>
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" width="80">
              <template #header>
                <span class="margin-0 item flex-col flex__center">
                  <span class="margin-bottom-5">Phối hợp</span>
                  <span>
                    <el-radio
                      class="hidden-label-radio"
                      :label="PROCESS_TYPE.PHOIHOP"
                      v-model="processType"
                      @change="checkAllProcessType"
                    >
                    </el-radio>
                  </span>
                </span>
              </template>
              <template slot-scope="scope">
                <el-radio
                  class="item txt-center hidden-label-radio"
                  v-model="scope.row.processType"
                  :label="PROCESS_TYPE.PHOIHOP"
                  @change="refreshProcessType()"
                >
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" width="120">
              <template #header>
                <span class="margin-0 item flex-col flex__center">
                  <span class="margin-bottom-5">Nhận để biết</span>
                  <span>
                    <el-radio
                      class="hidden-label-radio"
                      :label="PROCESS_TYPE.NHANDEBIET"
                      v-model="processType"
                      @change="checkAllProcessType"
                    >
                    </el-radio>
                  </span>
                </span>
              </template>
              <template slot-scope="scope">
                <el-radio
                  class="item txt-center hidden-label-radio"
                  v-model="scope.row.processType"
                  :label="PROCESS_TYPE.NHANDEBIET"
                  @change="refreshProcessType()"
                >
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column align="right" header-align="right" width="60">
              <template slot-scope="scope">
                <i
                  class="
                    el-icon-circle-close
                    clickable
                    font-size__large
                    color__red
                  "
                  @click="removeReceiversData(scope.row)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            class="btnPlain margin-top-10 margin-bottom-10"
            @click="isOpenSelectReceiverDialog = true"
          >
            <i class="fas fa-plus-circle"></i>
            Thêm đơn vị
          </el-button>
        </div>
        <!--ban hành đến (đơn vị bên trong):end-->

        <!--ban hành đến (trục liên thông văn bản)-->
        <el-row :gutter="12" v-if="isEnableBanHanhTrucLienThong">
          <el-col :span="24">
            <el-form-item
              label="Nơi nhận bên ngoài (trục liên thông văn bản)"
              prop="insideReceiver"
            >
              <el-select
                size="medium"
                class="
                  style-fullWidth
                  input-border__bottom input-border__radius__0
                "
                placeholder="Nhập tên đơn vị để tìm kiếm"
                v-model="form.tltvbAgencyIds"
                multiple
                filterable
                allow-create
                default-first-option
                remote
                reserve-keyword
                :remote-method="searchAgencies"
                :loading="isLoadingAgencies"
              >
                <el-option
                  v-for="(item, index) in tltvbAgencies"
                  :key="index"
                  :label="`${item.name} (${item.code} - ${item.mail})`"
                  :value="item.uuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!--ban hành đến (trục liên thông văn bản)-->

        <!--nơi nhận bên ngoài-->
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Nơi nhận bên ngoài" prop="insideReceiver">
              <el-select
                v-model="insideReceiver"
                multiple
                filterable
                allow-create
                default-first-option
                remote
                reserve-keyword
                :remote-method="remoteMethod"
                :loading="isLoading"
                class="
                  style-fullWidth
                  input-border__bottom input-border__radius__0
                "
              >
                <el-option
                  v-for="(item, index) in listInsideReceiver"
                  :key="index"
                  :label="item.deptName"
                  :value="item.deptName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!--nơi nhận bên ngoài:end-->

        <!--người nhận-->
        <div class="label flex-row flex__left">Người nhận</div>
        <div class="margin-bottom-10">
          <el-table
            ref="receiversDataTable"
            :data="selectedToUsers"
            size="mini"
            style="width: 100%"
            stripe
          >
            <el-table-column
              align="center"
              header-align="center"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              label="Người/Đơn vị được chuyển "
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="flex-row flex__left user_selected">
                  <div class="flex-row lex__left">
                    <div class="info margin-left-10">
                      <p class="people__name margin-0">
                        {{ scope.row.fullName }}
                      </p>
                      <p class="people__position margin-0">
                        {{ scope.row.positionName }} -
                        {{ scope.row.deptName }}
                      </p>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="right" header-align="right" width="60">
              <template slot-scope="scope">
                <i
                  class="
                    el-icon-circle-close
                    clickable
                    font-size__large
                    color__red
                  "
                  @click="removeSelectedToUsers(scope.row)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            class="btnPlain margin-top-10 margin-bottom-10"
            @click="isOpenSelectCCDialog = true"
          >
            <i class="fas fa-plus-circle"></i>
            Thêm người nhận
          </el-button>
        </div>
        <!--người nhận:end-->
      </div>
    </el-form>
    <dialog-add-book-number
      :isOpen="isOpenDialogAddBookNumber"
      v-if="isEnableVbBookDocCreateDialog"
      @submit="addBookNumber"
      @closed="isEnableVbBookDocCreateDialog = false"
      @closeDialog="isOpenDialogAddBookNumber = false"
    />

    <ky-token-dialog
      v-if="isEnableKyTokenDialog"
      :isOpen="isOpenKyTokenDialog"
      :vbAttachmentId="signedAttachmentId || vbAttachment.id"
      :isWatchingNote="false"
      :isAddSignature="true"
      :docId="docId"
      :docDate="form.docDate"
      :docCode="form.docCode"
      :publisherDept="publisherDepartment"
      :signDate="now"
      :isProcessing="isLoading"
      :needToSignCa="needToSignCa"
      @submit="afterAddSignature"
      @closed="isEnableKyTokenDialog = false"
      @closeDialog="isOpenKyTokenDialog = false"
    />

    <banhanh-select-receivers-dialog
      v-if="isEnableSelectReceiverDialog"
      :isOpen="isOpenSelectReceiverDialog"
      :receiversData="receiversData"
      @save="selectReceivers"
      @closed="isEnableSelectReceiverDialog = false"
      @closeDialog="isOpenSelectReceiverDialog = false"
      :docId="docId"
    >
    </banhanh-select-receivers-dialog>

    <banhanh-select-cc-dialog
      v-if="isEnableSelectCCDialog"
      :isOpen="isOpenSelectCCDialog"
      :selectedToUserIds="selectedToUserIds"
      @save="updateSelectedToUsers"
      @closed="isEnableSelectCCDialog = false"
      @closeDialog="isOpenSelectCCDialog = false"
      :docId="docId"
    >
    </banhanh-select-cc-dialog>

    <update-tltvb-required-data-dialog
      v-if="isEnableUpdateTltvbDataDialog"
      :isOpen="isOpenUpdateTltvbDataDialog"
      @closed="isEnableUpdateTltvbDataDialog = false"
      @closeDialog="isOpenUpdateTltvbDataDialog = false"
      @success="updateTltvbDataSuccess"
      :docId="docId"
    >
    </update-tltvb-required-data-dialog>
  </div>
</template>

<script>
import bookService from "../../../services/bookService";
import constants from "../../../constants";
import h from "../../../services/h";
import outgoingDocService from "../../../services/outgoingDocService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import departmentService from "../../../services/departmentService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import docInBookService from "../../../services/docInBookService.js";
import otherDepartmentService from "../../../services/otherDepartmentService";
import vbAttachmentTokenService from "../../../services/vbAttachmentTokenService";
import signTokenService from "../../../services/signTokenService";
import signTokenServiceViettel from "../../../services/signTokenServiceViettel";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import bookDocTypeService from "../../../services/bookDocTypeService";
import attachmentService from "../../../services/attachmentService";
import KyTokenDialog from "../../common/noteDocs/ky-token-dialog";
import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
import BanhanhDepartmentTree from "./banhanh-department-tree";
import BanhanhSelectReceiversDialog from "./banhanh-select-receivers-dialog";
import BanhanhSelectCcDialog from "./banhanh-select-cc-dialog";
import outgoingDocReceiversService from "../../../services/outgoingDocReceiversService";
import tltvbAgency from "../../../services/tltvbAgencyService";
import UpdateTltvbRequiredDataDialog from "../update-tltvb-required-data-dialog";
import DialogAddBookNumber from "./dialog-add-book-number";
import bookDocService from "../../../services/bookDocService";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  props: [
    "docId",
    "quote",
    "publisherId",
    "docStatus",
    "actionLog",
    "isHieuChinh",
    "otherReceivePlaces",
    "docTypeId",
    "deptEditorId",
    "signedAttachmentId",
  ],
  mixins: [handleRequestErrorMixin],
  components: {
    DialogAddBookNumber,
    UpdateTltvbRequiredDataDialog,
    BanhanhSelectCcDialog,
    BanhanhSelectReceiversDialog,
    BanhanhDepartmentTree,
    KyTokenDialog,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag.vue"),
    VuePerfectScrollbar,
  },

  data() {
    let validateDocDate = (rule, value, callback) => {
      if (!value) return;
      let truncDocDate = new moment(value).startOf("day");
      let truncNow = new moment(new Date()).startOf("day");
      return truncDocDate.diff(truncNow, "d") > 0
        ? callback(new Error("Ngày văn bản không được lớn ngày hiện tại !"))
        : callback();
    };

    return {
      insideReceiver: [],
      listInsideReceiver: [],
      isLoading: false,
      departmentTree: [],
      isOpenDialogAddBookNumber: false,
      isProcessing: false,
      isEnableVbBookDocCreateDialog: false,
      bookDocTypes: [],
      bookDocType: null,
      // settings: {
      //   maxScrollbarLength: 750
      // },
      search: null,
      books: [],
      book: null,
      publisherDepartment: null,
      vbAttachment: null,

      // toUsers: [],
      // toUserIds: [],
      selectedToUsers: [],
      // toUsersGroups: [],
      // toDeptIds: [],

      isOpenKyTokenDialog: false,
      isEnableKyTokenDialog: false,

      /**
       * validate khi active department-tree;
       */
      validationRules: {
        bookId: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
        bookNumber: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
        docCode: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
        docDate: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
          { validator: validateDocDate, trigger: "blur" },
        ],
      },

      form: {
        bookId: null,
        bookNumber: null,
        docCode: null,
        departmentIds: [],
        docDate: null,
        insideReceiver: null,
        tltvbAgencyIds: null,
      },

      bookDoc: null,

      DEPARTMENT: constants.DEPARTMENT,

      editorDepartment: null,
      outgoingDoc: null,
      docInBook: null,
      now: new Date(),
      receiversData: null,
      receiversDataInfo: null,

      isOpenSelectReceiverDialog: false,
      isEnableSelectReceiverDialog: false,
      isOpenSelectCCDialog: false,
      isEnableSelectCCDialog: false,

      docReceiverIds: null,
      PROCESS_TYPE: constants.PROCESS_TYPE,
      processType: null,

      tltvbAgencies: null,
      isLoadingAgencies: false,

      isEnableUpdateTltvbDataDialog: false,
      isOpenUpdateTltvbDataDialog: false,
    };
  },

  computed: {
    isEnableBanHanhTrucLienThong() {
      return this.publisherDepartment && this.publisherDepartment.agencyUuid;
    },
    isBanHanhTrucLienThong() {
      return this.form.tltvbAgencyIds && this.form.tltvbAgencyIds.length;
    },

    rootDeptId() {
      return this.publisherDepartment
        ? this.publisherDepartment.parentId || this.publisherDepartment.id
        : null;
    },
    isDaBanHanh() {
      return this.docStatus === constants.OUTGOING_DOC_STATUS.DABANHANH;
    },
    needToSignCa() {
      return this.publisherDepartment && this.publisherDepartment.needToSignCa;
    },
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },
    identityCode() {
      return this.$store.getters.userDeptRole.identityCode;
    },
    isKyNgoai() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.isKyNgoai === constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE
      );
    },
    isChonSo() {
      return this.bookDoc != null;
    },
    selectedToUserIds() {
      return h.collect(this.selectedToUsers, (item) => item.id);
    },
  },

  created() {
    this.initReceiversData();
  },

  mounted() {
    this.loadOutgoingDoc()
      .then(() => this.loadDocInBook())
      .then(() => this.loadBooks())
      .then(
        () =>
          (this.book = this.docInBook
            ? h.find(this.books, (item) => item.id === this.docInBook.bookId)
            : null)
      );

    this.loadPublisher();
    this.loadEditorDept();
    this.initDefaultToUsers();
    this.loadReceiveOtherDepts();
    this.loadReceiveAgencies();
  },

  watch: {
    publisherId(newValue) {
      newValue && this.loadPublisher();
    },
    isOpenDialogAddBookNumber(newValue) {
      newValue && (this.isEnableVbBookDocCreateDialog = newValue);
    },
    isProcessing(newValue) {
      this.$emit("processing", { isProcessing: newValue });
    },
    isOpenKyTokenDialog(newValue) {
      newValue && (this.isEnableKyTokenDialog = newValue);
    },
    isOpenSelectReceiverDialog(newValue) {
      newValue && (this.isEnableSelectReceiverDialog = newValue);
    },
    isOpenSelectCCDialog(newValue) {
      newValue && (this.isEnableSelectCCDialog = newValue);
    },
    isOpenUpdateTltvbDataDialog(newValue) {
      newValue && (this.isEnableUpdateTltvbDataDialog = newValue);
    },
  },

  methods: {
    //nếu điền số = tay & số này thuộc dải số đã book > thực hiện thông báo
    checkWithBookDoc() {
      return new Promise((resolve) => {
        if (!this.form.bookNumber || !this.form.bookId || this.isDaBanHanh) {
          resolve(null);
        } else {
          bookDocService
            .findByBookNumberAndBookId(this.form.bookNumber, this.form.bookId)
            .then((response) => {
              let bookDoc = response.data;
              if (bookDoc) {
                let confirmMessage = bookDoc.deptName
                  ? errorMessageFilter({
                      errorCode: "bookDoc.banhanhConfirm",
                      params: [
                        bookDoc.fromNumber,
                        bookDoc.toNumber,
                        dateFormatter(bookDoc.bookDocDate, {
                          dateFormat: constants.DEFAULT_DATE_FORMAT,
                        }),
                        bookDoc.deptName,
                      ],
                    })
                  : errorMessageFilter({
                      errorCode: "bookDoc.banhanhConfirm.noDeptName",
                      params: [
                        bookDoc.fromNumber,
                        bookDoc.toNumber,
                        dateFormatter(bookDoc.bookDocDate, {
                          dateFormat: constants.DEFAULT_DATE_FORMAT,
                        }),
                      ],
                    });

                this.$confirm(confirmMessage, {
                  confirmButtonText: "Lấy số",
                  cancelButtonText: "Tiếp tục",
                  type: "warning",
                })
                  .then(() => {
                    this.addBookNumber_(bookDoc, this.form.bookNumber);
                    resolve(bookDoc);
                  })
                  .catch(() => resolve(null));
              } else {
                resolve(null);
              }
            });
        }
      });
    },

    updateTltvbDataSuccess() {
      this.isOpenUpdateTltvbDataDialog = false;
      this.banHanh2_();
    },

    searchAgencies(query) {
      this.isLoadingAgencies = true;
      query = query.trim();
      (query
        ? tltvbAgency
            .findAllForBanHanh(query, this.docId, {
              sort: "name",
              page: 0,
              size: 100,
            })
            .then((res) => res.data)
        : Promise.resolve([])
      ).then((agencies) => {
        this.tltvbAgencies = agencies;
        this.isLoadingAgencies = false;
      });
    },

    loadReceiveDeparts(receiverObjectType) {
      return outgoingDocReceiversService
        .findAll({ docId: this.docId, objectType: receiverObjectType })
        .then((response) => response.data);
    },

    loadReceiveOtherDepts() {
      return this.loadReceiveDeparts(
        constants.RECEIVER_OBJECT_TYPE.DONVI_BENNGOAI
      ).then(
        (otherReceiveDepts) =>
          (this.insideReceiver = h.collect(
            h.findAll(
              otherReceiveDepts,
              (item) => item.isBanhanh !== constants.TRUE
            ),
            (item) => item.objectName
          ))
      );
    },

    loadReceiveAgencies() {
      return tltvbAgency
        .findAllDefaultForBanHanh(this.docId)
        .then((response) => {
          this.tltvbAgencies = response.data;
          this.form.tltvbAgencyIds = h.collect(
            this.tltvbAgencies,
            (item) => item.uuid
          );
        });
    },

    checkAllProcessType() {
      h.each(this.receiversDataInfo, (item) =>
        this.$set(item, "processType", this.processType)
      );
    },

    isOnlyProccessTypeChecked(processType) {
      return (
        this.receiversDataInfo &&
        this.receiversDataInfo.length &&
        !h.exists(
          this.receiversDataInfo,
          (item) => item.processType !== processType
        )
      );
    },

    refreshProcessType() {
      if (this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.CHUTRI)) {
        this.processType = constants.PROCESS_TYPE.CHUTRI;
      } else if (
        this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.NHANDEBIET)
      ) {
        this.processType = constants.PROCESS_TYPE.NHANDEBIET;
      } else if (
        this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.PHOIHOP)
      ) {
        this.processType = constants.PROCESS_TYPE.PHOIHOP;
      } else {
        this.processType = null;
      }
      // console.log(this.processType);
      // console.log(JSON.stringify(this.receiversDataInfo))
    },

    initReceiversData() {
      Promise.all([this.loadDocReceivers(), this.loadToDepartments()]).then(
        (results) => {
          let docReceivers = results[0];
          let toDepartments = results[1];
          let docReceiverIds = h.collect(docReceivers, (item) => item.objectId);
          let toDepartmentIds = h.collect(toDepartments, (item) => item.id);
          let receiverHandlerIds = [];
          h.each(docReceiverIds, (docReceiverId) => {
            if (
              h.exists(
                toDepartmentIds,
                (toDepartmentId) => toDepartmentId === docReceiverId
              )
            ) {
              receiverHandlerIds.push(docReceiverId);
            }
          });
          this.receiversData = { toDepartmentIds: receiverHandlerIds };
          this.populateReceiversDataInfo().then(() =>
            this.refreshProcessType()
          );
        }
      );
    },

    loadToDepartments() {
      return departmentService
        .findAllForBanHanh(this.docId)
        .then((response) => response.data);
    },

    loadDocReceivers() {
      return this.loadReceiveDeparts(constants.RECEIVER_OBJECT_TYPE.DONVI);
      // return vbOutgoingDocReceiversService
      //   .findAll({docId: this.docId, objectType: constants.RECEIVER_OBJECT_TYPE.DONVI})
      //   .then(response => response.data);
    },

    selectReceivers(event) {
      this.receiversData = event.receiversData;
      this.populateReceiversDataInfo().then(() => this.refreshProcessType());
      this.isOpenSelectReceiverDialog = false;
    },

    updateSelectedToUsers(event) {
      this.selectedToUsers = event.selectedToUsers;
      this.isOpenSelectCCDialog = false;
    },

    removeReceiversData(receiver) {
      let index = this.receiversDataInfo.indexOf(receiver);
      if (index !== -1) {
        this.receiversDataInfo.splice(index, 1);
        if (receiver.department) {
          let receiverDeptIds = this.receiversData.toDepartmentIds;
          receiverDeptIds.splice(
            receiverDeptIds.indexOf(receiver.department.id),
            1
          );
        } else if (receiver.userDeptRole) {
          let receiverHandlerIds = this.receiversData.toHandlerIds;
          receiverHandlerIds.splice(
            receiverHandlerIds.indexOf(receiver.userDeptRole.id),
            1
          );
        }
      }
      this.refreshProcessType();
    },

    loadOutgoingDoc() {
      return outgoingDocService.findById(this.docId).then((response) => {
        this.outgoingDoc = response.data;
        this.outgoingDoc.docDate &&
          (this.form.docDate = new Date(this.outgoingDoc.docDate));
        this.form.docCode = this.outgoingDoc.docCode;
      });
    },

    loadBookDocType() {
      return bookDocTypeService
        .findAllByBookIdAndDocTypeId(
          this.form.bookId,
          this.outgoingDoc.docTypeId
        )
        .then((response) => {
          this.bookDocType = h.find(
            response.data,
            (item) => item.status === constants.VB_BOOK_DOC_TYPE.STATUS.ACTIVE
          );
        });
    },

    remoteMethod(query) {
      if (query !== "") {
        this.findOtherDept(query);
      } else {
        this.options = [];
      }
    },

    findOtherDept(query) {
      this.isLoading = true;
      otherDepartmentService
        .search(query, this.deptId, { sort: "count,desc", page: 0, size: 20 })
        .then((res) => {
          this.listInsideReceiver = res.data;
          this.isLoading = false;
        });
    },

    addBookNumber(event) {
      this.addBookNumber_(event.bookDoc);
      this.isOpenDialogAddBookNumber = false;
    },

    addBookNumber_(bookDoc, bookNumber) {
      this.bookDoc = bookDoc;
      this.form.bookId = this.bookDoc.bookId;
      this.form.docDate = new Date(this.bookDoc.bookDocDate);
      this.form.bookNumber = bookNumber || this.bookDoc.currentNumber;
      this.book = h.find(this.books, (item) => item.id === this.form.bookId);
      this.generateDocCode();

      if (this.$refs.form) {
        this.$refs.form.validateField("bookId");
        this.$refs.form.validateField("docDate");
        this.$refs.form.validateField("bookNumber");
      }
    },

    isChuyenMon() {
      let currentDeptPath = this.$store.getters.userDeptRole.deptPath;
      return currentDeptPath.startsWith(
        constants.DEPARTMENT.DEPT_PATH.TCT_PATH
      );
    },

    //set mac dinh la lanh dao cua don vi thuc hien vao phan nguoi nhan;
    initDefaultToUsers() {
      return !this.isChuyenMon() || !this.deptEditorId
        ? Promise.resolve((this.selectedToUsers = null))
        : userDeptRoleViewService
            .findAllForDocOutCCDefault(this.publisherId, this.docId, {
              sort: ["positionOrder", "fullName"],
            })
            .then((response) => (this.selectedToUsers = response.data));
    },

    removeSelectedToUsers(toUser) {
      this.selectedToUsers.splice(this.selectedToUsers.indexOf(toUser), 1);
    },

    loadPublisher() {
      if (this.publisherId) {
        return departmentService.findById(this.publisherId).then((response) => {
          this.publisherDepartment = response.data;
        });
      }
    },

    loadEditorDept() {
      departmentService.findById(this.deptEditorId).then((response) => {
        this.editorDepartment = response.data;
      });
    },

    generateDocCode() {
      let prefix_ = this.bookDocType
        ? this.bookDocType.prefix
        : this.book
        ? this.book.prefix
        : "-";
      if (prefix_.charAt(0) !== "/") prefix_ = "/" + prefix_;
      let deptEditorIdentityCode = this.getIdentityCode();
      this.form.docCode = `${
        this.form.bookNumber || "-"
      }${prefix_}${deptEditorIdentityCode}`;

      this.$refs.form && this.$refs.form.validateField("docCode");
    },

    getIdentityCode() {
      // Nếu đơn vị ban hành khác đơn vị thực hiện thì sẽ thêm mã phòng ban của đơn vị thực hiện vào sau
      if (
        !this.editorDepartment ||
        !this.editorDepartment.identityCode ||
        this.editorDepartment.id === this.publisherId
      ) {
        return "";
      } else {
        return "";
        // return "-" + this.editorDepartment.identityCode;
      }
    },

    /**
     * ky thuc hien add anh;
     * @param cert
     * @param fileDataInBase64
     * @param index
     * @param tokenImages
     * @returns {*}
     * @private
     */
    signedWithToken2_(cert, fileDataInBase64, index, tokenImages) {
      let tokenImage = tokenImages[index];
      return new Promise((resolve, reject) => {
        signTokenService
          .signPdfV2({
            fileData: fileDataInBase64,
            certSerial: cert.Serial,
            signDate: null,
            fieldName: "",
            typeSign: "4",
            page: tokenImage.page.toString(),
            px: Math.round(tokenImage.px).toString(),
            py: Math.round(tokenImage.py).toString(),
            pw: Math.round(tokenImage.pw).toString(),
            ph: Math.round(tokenImage.ph).toString(),
            imageData: tokenImage.imageData.substring(
              "data:image/png;base64,".length
            ),
          })
          .then((response3) => {
            let signResult = response3.data;
            if (signResult.Status === constants.TOKEN_CA.STATUS.SUCCESS) {
              return resolve(
                index === tokenImages.length - 1
                  ? signResult
                  : this.signedWithToken2_(
                      cert,
                      signResult.FileDataSigned,
                      index + 1,
                      tokenImages
                    )
              );
            } else {
              this.notify(
                "Lỗi",
                errorMessageFilter({
                  errorCode: "tokenCA.signPdfError",
                  params: [signResult.ErrorDetail],
                }),
                "error",
                4000
              );
              reject(new Error("tokenCA.signPdfError"));
            }
          })
          .catch((error) => reject(error));
      });
    },

    banHanh() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.checkIsNeedUpdateForBanHanhTrucLT().then((isContinue) => {
            isContinue && this.banHanh2_();
          });
        } else {
          this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 4000);
        }
      });
    },

    banHanh2_() {
      return this.isDaBanHanh ||
        this.isKyNgoai
        ? this.needToSignCa !== 2 && this.needToSignCa !== 1 && this.signedAttachmentId
          ? this.banHanhNotSign()
          : this.banHanh_(null, null)
        : this.openKyTokenDialog();
    },

    banHanhNotSign() {
      vbAttachmentTokenService
        .downloadFileSigned(this.signedAttachmentId)
        .then((response) => {
          return attachmentService
            .uploadSignedPdf(
              this.docId,
              constants.ATTACHMENT_OBJECT_TYPE
                .VB_DI_SIGNED_WITH_TOKEN_WITHOUT_STAMP,
              response.data
            )
            .then((res) => res.data);
        })
        .then((signedAttachment) => {
          this.banHanh_(null, signedAttachment.id);
        });
    },

    checkIsNeedUpdateForBanHanhTrucLT() {
      return new Promise((resolve) => {
        if (this.isBanHanhTrucLienThong) {
          if (
            this.outgoingDoc.isLawDocument == null ||
            this.outgoingDoc.steeringType == null ||
            this.outgoingDoc.signerUserDeptRoleId == null
          ) {
            this.$confirm(
              errorMessageFilter({
                errorCode: "banhanh.confirmUpdateForBanHanhTltvbMessage",
              }),
              {
                confirmButtonText: "Bổ sung",
                cancelButtonText: "Hủy bỏ",
                type: "info",
              }
            )
              .then(() => {
                this.openUpdateTltvbRequiredDataDialog();
                resolve(false);
              })
              .catch(() => resolve(false));
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    },

    openUpdateTltvbRequiredDataDialog() {
      this.isOpenUpdateTltvbDataDialog = true;
    },

    populateReceiversDataInfo() {
      let receiversData = this.receiversData;
      let receiverDeptIds = receiversData.toDepartmentIds;
      let receiverHandlerIds = h.collect(
        receiversData.toHandlersData,
        (handlerInfoItem_) => handlerInfoItem_.userDeptRoleId
      );
      return Promise.all([
        receiverDeptIds && receiverDeptIds.length
          ? departmentService
              .findAllByIdIn(receiverDeptIds)
              .then((response) => response.data)
          : Promise.resolve([]),
        receiverHandlerIds && receiverHandlerIds.length
          ? userDeptRoleViewService
              .findAllByIdIn(receiverHandlerIds)
              .then((response) => response.data)
          : Promise.resolve([]),
      ])
        .then((results) => {
          this.receiversDataInfo = [];
          let departments = results[0];
          let userDeptRoles = results[1];
          h.each(userDeptRoles, (userDeptRole) => {
            let toHandlersInfoItem = h.find(
              receiversData.toHandlersData,
              (handlerInfoItem_) =>
                handlerInfoItem_.userDeptRoleId === userDeptRole.id
            );
            this.receiversDataInfo.push({
              userDeptRole: userDeptRole,
              processType: constants.PROCESS_TYPE.CHUTRI,
              vbStepInfoId: toHandlersInfoItem.vbStepInfoId,
            });
          });
          h.each(departments, (department) =>
            this.receiversDataInfo.push({
              department: department,
              processType: constants.PROCESS_TYPE.CHUTRI,
            })
          );
        })
        .catch((error) => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    banHanh_(signedVbAttachmentId, signedWithoutStampVbAttachmentId) {
      this.isProcessing = true;
      let receiverDepts = [];
      let receiverHandlers = [];
      h.each(this.receiversDataInfo, (receivers) => {
        if (receivers.department) {
          receiverDepts.push({
            id: receivers.department.id,
            processType: receivers.processType,
          });
        } else if (receivers.userDeptRole) {
          receiverHandlers.push({
            id: receivers.userDeptRole.id,
            processType: receivers.processType,
            vbStepInfoId: receivers.vbStepInfoId,
          });
        }
      });
      let submitForm = {
        bookDocId: this.bookDoc ? this.bookDoc.id : "",
        outgoingDocId: this.docId,
        receiverDepts: receiverDepts,
        receiverHandlers: receiverHandlers,
        toUserIds: this.selectedToUserIds,
        bookId: this.form.bookId,
        bookNumber: this.form.bookNumber,
        docCode: this.form.docCode,
        insideReceiver: this.insideReceiver.join(","),
        otherDepartments: this.insideReceiver,
        docDate: this.form.docDate.getTime(),
        actionLogId: this.actionLog ? this.actionLog.id : null,
        signedVbAttachmentId: signedVbAttachmentId,
        signedWithoutStampVbAttachmentId: signedWithoutStampVbAttachmentId,
        tltvbAgencyIds: this.form.tltvbAgencyIds,
      };
      return this.updateData().then((res) => {
        return outgoingDocService
          .banHanhVanBan(submitForm)
          .then(() => {
            this.message(
              "Thông báo",
              "Ban hành văn bản thành công!",
              "success",
              4000
            );
            this.$emit("success");
            localStorage.removeItem("accessTokenSCA");
            this.isProcessing = false;
          })
          .catch((error) => {
            this.isProcessing = false;
            this.commonHandleRequestError(error);
            throw error;
          });
      });
    },

    async updateData() {
      await this.$emit("update");
    },

    openKyTokenDialog() {
      this.loadAttachment().then(() => (this.isOpenKyTokenDialog = true));
    },

    /**
     * ham nay dung cho TH ban hanh khong can token;
     */
    uploadModifiedPage(pagesData) {
      return Promise.all(
        h.collect(pagesData, (pageData) => {
          let imageURI = pageData.pageImageData.pageImage;
          return vbOutgoingProcessService
            .uploadImageSign({
              base64: imageURI.substring(imageURI.indexOf(",") + 1),
              pageNumber: pageData.pageIndex,
              objectId: this.docId,
            })
            .then((res) => res.data.id);
        })
      )
        .then((imageFileIds) =>
          vbOutgoingProcessService.exportFileBanHanh(this.docId, {
            imageFileIds: imageFileIds,
          })
        )
        .then((response) => response.data);
    },

    /**
     * ham nay dung cho TH ban hanh co token viettel;
     */

    uploadModifiedPageTokenViettel(certBase64, pagesData) {
      return Promise.all(
        h.collect(pagesData, (pageData) => {
          let imageURI = pageData.pageImageData.pageImage;
          return vbOutgoingProcessService
            .uploadImageSignViettel({
              certBase64: certBase64,
              base64: imageURI.substring(imageURI.indexOf(",") + 1),
              pageNumber: pageData.pageIndex,
              objectId: this.docId,
            })
            .then((res) => res.data.id);
        })
      )
        .then((imageFileIds) =>
          vbOutgoingProcessService.exportFileBanHanh(this.docId, {
            imageFileIds: imageFileIds,
          })
        )
        .then((response) => response.data);
    },

    convertPagesDataToTokenImages(pagesData, excludeShapeTypes) {
      let tokenImages = [];
      let ratio =
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_72_PPI /
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_150_PPI;
      h.each(pagesData, (pageData) => {
        let pageSize = pageData.pageImageData.size;
        h.each(pageData.pageImageData.shapeImages, (shapeImage) => {
          if (
            excludeShapeTypes &&
            excludeShapeTypes.indexOf(shapeImage.shapeType) !== -1
          )
            return;
          let shapePosition = shapeImage.position;
          let shapeSize = shapeImage.size;
          tokenImages.push({
            page: pageData.pageIndex + 1,
            px: shapePosition.x * ratio,
            py: (pageSize.height - shapePosition.y - shapeSize.height) * ratio,
            pw: (shapePosition.x + shapeSize.width) * ratio,
            ph: (pageSize.height - shapePosition.y) * ratio,
            imageData: shapeImage.uri,
          });
        });
      });
      return tokenImages;
    },

    getStempTokem(pagesData, excludeShapeTypes) {
      let tokenImages = [];
      let ratio =
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_72_PPI /
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_150_PPI;
      h.each(pagesData, (pageData) => {
        let pageSize = pageData.pageImageData.size;
        h.each(pageData.pageImageData.shapeImages, (shapeImage) => {
          if (
            excludeShapeTypes &&
            excludeShapeTypes.indexOf(shapeImage.shapeType) === -1
          )
            return;
          let shapePosition = shapeImage.position;
          let shapeSize = shapeImage.size;
          tokenImages.push({
            page: pageData.pageIndex + 1,
            px: shapePosition.x * ratio,
            py: (pageSize.height - shapePosition.y - shapeSize.height) * ratio,
            pw: (shapePosition.x + shapeSize.width) * ratio,
            ph: (pageSize.height - shapePosition.y) * ratio,
            imageData: shapeImage.uri,
          });
        });
      });
      return tokenImages;
    },

    convertPagesDataToSCAImages(pagesData, excludeShapeTypes) {
      let tokenImages = [];
      let ratio =
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_72_PPI /
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_150_PPI;
      h.each(pagesData, (pageData) => {
        let pageSize = pageData.pageImageData.size;
        h.each(pageData.pageImageData.shapeImages, (shapeImage) => {
          if (
            excludeShapeTypes &&
            excludeShapeTypes.indexOf(shapeImage.shapeType) !== -1
          )
            return;
          let shapePosition = shapeImage.position;
          let shapeSize = shapeImage.size;
          tokenImages.push({
            page: pageData.pageIndex + 1,
            recComment: `${Math.round(shapePosition.x * ratio)},${Math.round(
              (pageSize.height - shapePosition.y - shapeSize.height) * ratio
            )},${Math.round(
              (shapePosition.x + shapeSize.width) * ratio
            )},${Math.round((pageSize.height - shapePosition.y) * ratio)}`,
            base64Image: shapeImage.uri,
            type: 1,
          });
        });
      });
      return tokenImages;
    },

    getStempSCA(pagesData, excludeShapeTypes) {
      let tokenImages = [];
      let ratio =
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_72_PPI /
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_150_PPI;
      h.each(pagesData, (pageData) => {
        let pageSize = pageData.pageImageData.size;
        h.each(pageData.pageImageData.shapeImages, (shapeImage) => {
          if (
            excludeShapeTypes &&
            excludeShapeTypes.indexOf(shapeImage.shapeType) === -1
          )
            return;
          let shapePosition = shapeImage.position;
          let shapeSize = shapeImage.size;
          tokenImages.push({
            page: pageData.pageIndex + 1,
            recSign: `${Math.round(shapePosition.x * ratio)},${Math.round(
              (pageSize.height - shapePosition.y - shapeSize.height) * ratio
            )},${Math.round(
              (shapePosition.x + shapeSize.width) * ratio
            )},${Math.round((pageSize.height - shapePosition.y) * ratio)}`,
            imageSign: shapeImage.uri,
            typeSign: 3,
          });
        });
      });
      return tokenImages;
    },

    getCert() {
      return signTokenService
        .getCert("")
        .then((response2) => response2.data)
        .catch((error) => {
          this.notify(
            "Lỗi",
            errorMessageFilter({ errorCode: "tokenCA.error" }),
            "error",
            4000
          );
          throw error;
        });
    },

    downloadOriginalOutgoingDocForVTAsBase64() {
      if (this.signedAttachmentId) {
        return vbAttachmentTokenService
          .downloadFileSigned(this.signedAttachmentId)
          .then((response) => response.data)
          .catch((error) => {
            this.commonHandleRequestError(error);
            throw error;
          });
      }
      return vbAttachmentTokenService
        .downloadOriginalOutgoingDocForVTAsBase64(this.docId)
        .then((response) => response.data)
        .catch((error) => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    uploadSignedPdf(cert, base64String, tokenImages, objectType) {
      return this.signedWithToken2_(cert, base64String, 0, tokenImages)
        .then((signedResult) =>
          attachmentService.uploadSignedPdf(
            this.docId,
            objectType,
            signedResult.FileDataSigned
          )
        )
        .then((response) => response.data);
    },

    signTokenViettel(
      // hSession,
      // certUserBase64,
      tokenImages,
      base64String,
      index
    ) {
      return new Promise((resolve, reject) => {
        let { hSession, certUserBase64 } =
          signTokenServiceViettel.getSessionSign();
        if (!certUserBase64) {
          this.$message({
            message: "Không lấy được token!",
            type: "error",
          });
          this.isProcessing = false;
          return;
        }
        attachmentService
          .getHashSignViettel(
            this.docId,
            certUserBase64,
            tokenImages[index],
            base64String
          )
          .then((resHashSign) => {
            // Bước 3: Lấy chữ ký
            let signatureBase64 = signTokenServiceViettel.signHash(
              hSession,
              resHashSign.data.hashBase64
            );
            return attachmentService.signViettel(
              this.docId,
              signatureBase64,
              tokenImages[index],
              base64String
            );
          })
          .then((res) => {
            return resolve(
              index === tokenImages.length - 1
                ? res
                : this.signTokenViettel(
                    // hSession,
                    // certUserBase64,
                    tokenImages,
                    res.data,
                    index + 1
                  )
            );
          });
      });
    },

    uploadSignedPdfViettel(
      objectType,
      tokenImages,
      // hSession,
      // certUserBase64,
      base64String
    ) {
      return this.signTokenViettel(
        // hSession,
        // certUserBase64,
        tokenImages,
        base64String,
        0
      )
        .then((res) => {
          return attachmentService.uploadSignedPdf(
            this.docId,
            objectType,
            res.data
          );
        })
        .then((response) => response.data);
    },

    uploadSignedPdfSCA(
      objectType,
      tokenImages,
      tokenImagesStamp,
      base64String,
      username,
      password
    ) {
      return attachmentService
        .signFileWithPassword({
          ...tokenImagesStamp[0],
          fileContent: base64String,
          fileName: this.quote,
          commentSignatures: tokenImages,
          username,
          password,
        })
        .then((res) => {
          return attachmentService.uploadSignedPdf(
            this.docId,
            objectType,
            res.data
          );
        })
        .then((response) => response.data)
        .catch((err) => {
          this.isLoading = false;
          if (
            err && 
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0] &&
            err.response.data.errors[0].params
          ) {
            this.$message({
              message: err.response.data.errors[0].params,
              type: "error",
            });
          } else {
            this.$message({
              message: "Ký số thất bại!",
              type: "error",
            });
          }
        });
    },

    signedWithToken2(pagesData) {
      return this.getCert()
        .then((cert) =>
          this.downloadOriginalOutgoingDocForVTAsBase64().then(
            (base64String) => {
              return {
                cert: cert,
                base64String: base64String,
              };
            }
          )
        )
        .then((result) => {
          let cert = result.cert;
          let base64String = result.base64String;
          let tokenImages = this.convertPagesDataToTokenImages(pagesData, null);
          let tokenImagesWithoutStamp = this.convertPagesDataToTokenImages(
            pagesData,
            [constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU]
          );
          this.uploadSignedPdf(
            cert,
            base64String,
            tokenImages,
            constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN
          ).then((signedVbAttachment) => {
            this.uploadSignedPdf(
              cert,
              base64String,
              tokenImagesWithoutStamp,
              constants.ATTACHMENT_OBJECT_TYPE
                .VB_DI_SIGNED_WITH_TOKEN_WITHOUT_STAMP
            ).then((signedWithoutStampVbAttachment) => {
              this.banHanh_(
                signedVbAttachment.id,
                signedWithoutStampVbAttachment.id
              );
            });
          });
        });
    },

    afterAddSignature(event) {
      let pagesData = event.pagesData;
      this.isLoading = true;
      if (
        this.signedAttachmentId &&
        this.needToSignCa !== 2 &&
        this.needToSignCa !== 1
      ) {
        this.$message({
          message: "Lãnh đạo đã ký số nên văn thư phải ký số!",
          type: "error",
        });
        return;
      }
      if (this.needToSignCa === 1) {
        // Lấy tất cả comment
        let tokenImages = this.convertPagesDataToSCAImages(pagesData, null);
        // Lấy con dấu
        let tokenImagesStamp = this.getStempSCA(pagesData, [
          constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU,
        ]);
        if (!tokenImagesStamp || !tokenImagesStamp.length) {
          this.$message({
            message: "Bạn chưa chọn con dấu!",
            type: "error",
          });
          return;
        }
        return this.downloadOriginalOutgoingDocForVTAsBase64()
          .then((base64String) => {
            return base64String;
          })
          .then((resBase64String) => {
            return this.uploadSignedPdfSCA(
              constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN,
              tokenImages,
              tokenImagesStamp,
              resBase64String,
              event.username,
              event.password
            ).then((signedVbAttachment) => {
              return this.banHanh_(signedVbAttachment.id, null);
            });
          })
          .then(() => {
            this.isLoading = false;
            this.isOpenKyTokenDialog = true;
          })
          .catch(() => {
            this.isLoading = false;
            console.log("Ký thất bại");
          });
      } else if (this.needToSignCa === 2) {
        let tokenImages = this.convertPagesDataToTokenImages(pagesData, null);
        let tokenImagesStamp = this.getStempTokem(pagesData, [
          constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU,
        ]);
        // return;
        if (!tokenImagesStamp || !tokenImagesStamp.length) {
          this.$message({
            message: "Bạn chưa chọn con dấu!",
            type: "error",
          });
          return;
        }
        this.downloadOriginalOutgoingDocForVTAsBase64()
          .then((base64String) => {
            return base64String;
          })
          .then((resBase64String) => {
            this.uploadSignedPdfViettel(
              constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN,
              tokenImages,
              resBase64String
            ).then((signedVbAttachment) => {
              this.banHanh_(signedVbAttachment.id, null);
            });
          })
          .then(() => {
            this.isLoading = false;
            this.isOpenKyTokenDialog = true;
          });
      } else {
        /**
         * truong hop khong can ky token
         */
        this.uploadModifiedPage(pagesData)
          .then(() => {
            if(this.signedAttachmentId) {
              this.banHanhNotSign();
            } else {
              this.banHanh_(null, null);
            }
          })
          .then(() => {
            this.isLoading = false;
            // this.isOpenKyTokenDialog = true;
          })
          .catch((error) => {
            this.isLoading = false;
            throw error;
          });
      }
    },

    loadAttachment() {
      return attachmentService
        .findAll({
          objectId: this.docId,
          objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI,
        })
        .then((response) => {
          if (response.data && response.data.length) {
            this.vbAttachment = response.data[0];
          }
        });
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.search);
    },

    loadDocInBook() {
      return docInBookService.findByDocId(this.docId).then((response) => {
        if (response.data) {
          this.docInBook = response.data;
          this.form.bookId = this.docInBook.bookId;
          this.form.bookNumber = this.docInBook.bookNumber;
        }
      });
    },

    loadBooks() {
      return bookService
        .getAllBook(
          {
            bookType: constants.BOOK_TYPE.VB_DI,
            includeIds: this.docInBook ? [this.docInBook.bookId] : null,
            vbBookStatus: constants.VB_BOOK.STATUS.ACTIVE,
          },
          { sort: "bookName,asc", page: 0 }
        )
        .then((response) => (this.books = response.data));
    },

    bookIdChange() {
      this.$refs.form.validateField("bookId");
      this.checkWithBookDoc().then((bookDoc) => {
        if (this.form.bookId) {
          if (bookDoc == null) {
            this.book = h.find(
              this.books,
              (item) => item.id === this.form.bookId
            );
            this.form.bookNumber = (this.book.bookCurrentNumber || 0) + 1;
            this.loadBookDocType().then(() => this.generateDocCode());
          }
        } else {
          this.book = null;
          this.form.bookNumber = 0;
          this.form.docCode = null;
        }
      });
    },

    bookNumberChange() {
      this.checkWithBookDoc().then(
        (bookDoc) => !bookDoc && this.generateDocCode()
      );
    },
  },
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  padding-bottom: 0;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 200px;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// src/views/doc-out/components/BHanhDocOut.vue